/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetOrdersToShipResponseDto } from '../../models/get-orders-to-ship-response-dto';

export interface MgmtOrdersToShipControllerGetMany$Params {
  orderIds?: Array<number>;
  shopOrderIds?: Array<number>;
}

export function mgmtOrdersToShipControllerGetMany(http: HttpClient, rootUrl: string, params?: MgmtOrdersToShipControllerGetMany$Params, context?: HttpContext): Observable<StrictHttpResponse<GetOrdersToShipResponseDto>> {
  const rb = new RequestBuilder(rootUrl, mgmtOrdersToShipControllerGetMany.PATH, 'get');
  if (params) {
    rb.query('orderIds', params.orderIds, {});
    rb.query('shopOrderIds', params.shopOrderIds, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetOrdersToShipResponseDto>;
    })
  );
}

mgmtOrdersToShipControllerGetMany.PATH = '/api/mgmt-orders/to-ship';
